import Vue from "vue";
import Vuelidate from "vuelidate";
import App from "./App.vue";
import "./assets/tailwind.css";
import BaseButton from "./components/BaseButton.vue";
import router from "./router";
import formival from "./formival";
import store from "./store";

Vue.use(Vuelidate);

Vue.component("BaseButton", BaseButton);

Vue.config.productionTip = false;

new Vue({
  router,
  formival,
  store,
  render: h => h(App)
}).$mount("#app");
